/**
 * Funkcja czyszcząca localStorage ze wszystkich danych zapisanych przez użytkownika
 *
 * @returns {void}
 */
export default function clearLocalStorage() {
  localStorage.removeItem('configurator-background');
  localStorage.removeItem('boxesVisibility');
}
